<template>
  <v-container>
    <v-row  dense>
      <v-col cols="12">
        <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import DataTableMain from '@/components/tables/DataTableMain'
import { UserSession } from '@/store/modules/config'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'catalogo.partidas.create-update' }
        ],
        titles: [
          { text: 'Cuenta', value: 'cuenta', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Descripcion', value: 'descripcion', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsGral', class: 'black--text', align: 'right' }
        ],
        loading: false,
        filter: true
      },
      body: {
        data: [],
        actions: [
          { title: 'Activar / Desactivar', icon: 'mdi-checkbox-blank-circle', color: 'grey darken-3', action: 'disableData', code: 'catalogo.partidas.up-down' },
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-3', action: 'updateData', code: 'catalogo.partidas.create-update' },
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-3', action: 'deleteData', code: 'catalogo.partidas.delete' }
        ]
      },
      footer: {
        paging: true
      }
    },
    user: {}
  }),
  components: {
    DataTableMain
  },
  mounted () {
    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'PUTDisableEnableObjectService', 'DELETEObjectService']),
    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN', 'SHOW_DIALOG_ALERT_MAIN']),
    SuccessTableAction (item) {
      this[item.action](item)
    },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.GETObjects({ url: router })
      } else { this.getUrlServices() }
    },
    /* *==========*==========*==========*==========*==========*==========*==========*==========* */
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('catalogo.partidas.show')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '40%',
        title: 'Nuevo Departamento',
        body: {
          objectMain: { empresa_id: this.user.empresa_id },
          paramsDialog: {
            form: this.get_PartidasForm,
            url: this.get_urls['catalogo.partidas.create-update'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    disableData  ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'disable',
        with: '40%',
        title: `${name} Departamento`,
        body: {
          objectMain: item,
          url: this.get_urls['catalogo.partidas.up-down'],
          message: `¿Estás seguro en ${name} el registro?`,
          description: ''
        },
        confirmButtonText: `Sí, ${name}`,
        cancelButtonText: 'No, Cancelar'
      })
    },
    updateData ({ item }) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '40%',
        title: 'Editar Departamento',
        body: {
          objectMain: item,
          paramsDialog: {
            form: this.get_PartidasForm,
            url: this.get_urls['catalogo.partidas.create-update'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    deleteData  ({ item }) {
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'delete',
        with: '40%',
        title: 'Eliminar Departamento',
        body: {
          objectMain: item,
          url: this.get_urls['catalogo.partidas.delete'],
          message: '¿Estás seguro de eliminar el registro?',
          description: 'No podras revertir el movimiento'
        },
        confirmButtonText: 'Sí, Eliminar',
        cancelButtonText: 'No, Cancelar'
      })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_dialogMain',
      'get_PartidasForm'])
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        this.table.header.loading = false
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
